export default __webpack_public_path__ + "static/media/Girdle of Bone and Horn.4bd236f9.jpg";